import * as React from "react";
import { connect } from "react-redux";
import { TextField } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { BackButton } from "../../views/common-forms/components";
import { CANCEL } from "../../shared/timeclock/actions";
import { SettingsInfo } from "../components";
import { Session, SignatureRegistry } from "../reducers";
import { Config } from "../../shared/timeclock/models";
import { Messages } from "../messages";
import { Action, Dispatch } from "redux";

require("../../views/common/font-awesome-custom.scss");

export interface SettingsProps {
    signatures?: SignatureRegistry;
    session?: Session;
    config?: Config;
    offlinestamps?: number;

    dispatch?: Dispatch<Action, unknown>;
}

interface SettingsState {
    guidErrorText?: string;
}

function mapStateToProps(state) {
    return {
        session: state.session,
        signatures: state.signatures,
        config: state.config,
        offlinestamps: state.offline.length
    };
}

const connector = connect(mapStateToProps);

class _Settings extends React.Component<SettingsProps, SettingsState> {
    constructor(props: SettingsProps) {
        super(props);

        this.state = {
            guidErrorText: "",
        };
    }

    guidChanged = (event: React.FocusEvent<HTMLInputElement>) => {
        const isValidGuid = this.isValidGuid(event.target.value);

        this.setState({
            guidErrorText: isValidGuid ? "" : "Not valid!",
        });

        if (!isValidGuid) {
            return;
        }
    };

    goBack = () => {
        const { dispatch } = this.props;

        dispatch({ type: CANCEL });
    };

    isValidGuid(value: string) {
        const regex = /^(\{){0,1}[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(\}){0,1}$/gi;
        return regex.test(value);
    }

    render() {
        const { config } = this.props;

        return (
            <div className="settings">
                <h2><FormattedMessage {...Messages.Settings} /></h2>

                <div className="settings-body">
                    <div className="guid-api">
                        <TextField
                            disabled={true}
                            defaultValue={config.terminalGuid}
                            label="Terminal guid"
                            onBlur={this.guidChanged}
                            variant="standard"
                        />
                        <TextField
                            disabled={true}
                            defaultValue={config.serverUrl}
                            label="API Address"
                            variant="standard"
                        />
                    </div>
                    <SettingsInfo {...this.props} />
                </div>
                <hr />
                <BackButton onClick={this.goBack} />
            </div>
        );
    }
}

export const Settings = connector(_Settings);
